import ApiClient from "../../api/src/ApiClient";
import Storage from "./BrandStorage";

export default {
  namespaced: true,

  state: {
    list: [],
    selected: [],
    filters: []
  },

  mutations: {
    list(state, response) {
      state.list = response;
    }
  },

  actions: {
    saveStorage({ state }) {
      Storage.saveParams(state.selected);
    },

    selected({ commit, state }, brand) {
      state.selected = brand.brand;
      if (brand.top) {
        this.dispatch("search/selectedProducerClear", [brand.brand.id]);
      } else {
        this.dispatch("search/selectedProducer", [brand.brand.id]);
      }
    },

    setFilters({ commit, state }, filters) {
      state.filters = filters;
    },

    async requestData({ commit, state }) {
      const result = await ApiClient.get("shop/brands");
      const sortedResult = result.data.sort((a, b) => {
        const brandA = a.name.toUpperCase();
        const brandB = b.name.toUpperCase();
        let comparison = 0;
        if (brandA > brandB) comparison = 1;
        else if (brandA < brandB) comparison = -1;
        return comparison;
      });
      commit("list", sortedResult);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/brands-carousel/src/BrandStore.js